import {mapValues, difference, keys, omit, keyBy, createReducer} from 'helpers';

export const tags = createReducer({}, {

  TAGS_NEW: (state, { id, name }) => {
    if (!state[id]) {
      return {
        ...state,
        [id]: { id, name },
      }
    }
    return state;
  },

  TAGS_UPDATE(state, {tags, deleted}) {
    return omit(mapValues(state, tag => ({
      ...tag,
      name: tags[tag.id] ?? tag.name
    })), deleted);
  },

  SERVER_DATA_RECEIVED: (state, action) => {
    const removed = difference(keys(state), action.existingElementIds.tags);
    if (action.tags.length || removed.length) {
      return omit({
        ...state,
        ...keyBy(action.tags, 'id'),
      }, removed);
    }
    return state;
  }

});
